import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon, Sales } from '../../../config/variables';
import { hasPermission, navigateRoute } from '../../../utils/HelperFunctions';
import { ILead } from '../types/interfaces';
import { ITableContainerProps } from '../../../types/Interfaces';
import DeleteButton from '../../../components/buttons/DeleteButton';

const LeadsTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: ITableContainerProps<ILead[]>) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map((header, index) =>
          !header ? null : (
            <span className={`head ${header.customClass}`} key={index}>
              {header.label}
            </span>
          )
        )}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item, index) => (
              <div
                className={`item clickable has_logo fuel_types`}
                key={index}
                onClick={(e) => {
                  navigateRoute(e, `/leads/create-lead/${item.id}`, navigate);
                }}
              >
                <div className="column">
                  <div className="capitalize">{item?.first_name || '-'}</div>
                </div>
                <div className="column">
                  <div className="capitalize">{item?.last_name || '-'}</div>
                </div>
                <div className="column">{item?.email || '-'}</div>
                <div className="column">{item?.mobile || '-'}</div>
                <div className="column">{item?.assigned_sales ? `${item?.assigned_sales?.first_name} ${item?.assigned_sales?.last_name}` : '-'}</div>
                <div className="column">{item?.provider_lead_id || '-'}</div>
                {/* {hasPermission(['leeds.edit']) && ( */}
                <div className="column actions actions_col">
                  {hasPermission(['leeds.assign_sales_to_leads']) && (
                    <div
                      className="action_btn edit"
                      onClick={(e) => {
                        navigateRoute(e, `/leads/assigned-sales/${item.id}`, navigate);
                      }}
                    >
                      {Sales}
                    </div>
                  )}
                  <div
                    className="action_btn edit"
                    onClick={(e) => {
                      navigateRoute(e, `/leads/create-lead/${item.id}`, navigate);
                    }}
                  >
                    {editIcon}
                  </div>
                  <DeleteButton deleteRoute={`/admin/leads`} queryKey="leads" id={item.id} />
                </div>
                {/* )} */}
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default LeadsTableContainer;
